import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import "../../style/cityAndCountry/AddCity.scss";
import {
  get_timezone,
  add_city,
  get_state,
  get_city_details,
  update_city,
  get_country
} from "../../redux/actions/countryCityActions";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import isEmpty from "lodash.isempty";
import loader from "../../style/loader/loader.scss";

const history = createHashHistory();

class AddCity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      state: "",
      stateAbbr: "",
      country: "",
      countryName: "",
      timezone: "",
      //nationalMultiplier: "",
      latitude: "",
      longitude: "",
      cityID: "",
      countries: [],
      countryStates: [],
      cityDetailsForEdit: {},
      timezones: [],
      path: ["Home", "Cities", "Add New City"],
      links: ["home","cityAndCountry","AddCity"],
      alertMessage: "",
      msgType: "",
      show: false,
      isLoading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStateSelect = this.handleStateSelect.bind(this);
    this.handleTimezoneSelect = this.handleTimezoneSelect.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentWillMount(e) {
    this.props.get_country();
    this.props.get_timezone();
    let cityIdParams = this.props.match.params.cityId
      ? this.props.match.params.cityId
      : "";
    if (cityIdParams !== "") {
      const editLink = `AddCity/${cityIdParams}`
      this.props.get_city_details(cityIdParams);
      this.state.path = ["Home", "Cities", "Edit City"];
      this.state.links = ["home","cityAndCountry",editLink];
    }
  }

  componentWillUnmount() {
    this.setState({ alertMessage: "", msgType: "", show: false });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.states !== nextProps.states && !isEmpty(nextProps.states)) {
      this.setState({ countryStates: nextProps.states });
    }
    if (this.props.fetchingState !== nextProps.fetchingState) {
      this.setState({ isLoading: nextProps.fetchingState });
    }
    if (this.props.fetchCity !== nextProps.fetchCity) {
      this.setState({ isLoading: nextProps.fetchCity });
    }
    if (
      this.props.countries !== nextProps.countries &&
      !isEmpty(nextProps.countries)
    ) {
      this.setState({ countries: nextProps.countries });
    }

    if (
      this.props.timezones !== nextProps.timezones &&
      !isEmpty(nextProps.timezones)
    ) {
      this.setState({ timezones: nextProps.timezones });
    }

    if (
      this.props.cityDetails !== nextProps.cityDetails &&
      !isEmpty(nextProps.cityDetails)
    ) {
      this.setState({ cityDetailsForEdit: nextProps.cityDetails.data });
      let cityDetails = nextProps.cityDetails.data;
      this.setState({
        cityID: cityDetails.cityID,
        title: cityDetails.title,
        state: cityDetails.state,
        stateAbbr: cityDetails.stateAbbr,
        country: cityDetails.country,
        countryName: cityDetails.countryName,
        timezone: cityDetails.timezone,
        //nationalMultiplier: cityDetails.nationalMultiplier,
        latitude: cityDetails.latitude,
        longitude: cityDetails.longitude
      });
      this.props.get_state(cityDetails.country);
    }
    if (this.props.error !== nextProps.error) {
      this.setState({
        alertMessage: nextProps.error,
        msgType: "warning",
        show: true
      });
    }
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handleBlur(e) {
    if (e.target.value.length > 0) {
      // if (e.target.name === "nationalMultiplier") {
      //   if (!/^\d+$/.test(e.target.value)) {
      //     this.setState({
      //       [`${e.target.name}Error`]: "Numeric values in National Multiplier"
      //     });
      //   }
      // } 
      if (e.target.name === "latitude") {
        if (
          !/^-?([1]?[1-7][1-9]|[1]?[1-8][0]|[1-9]?[0-9])\.{1}\d{1,6}$/.test(
            e.target.value
          )
        ) {
          this.setState({ [`${e.target.name}Error`]: "Invalid Latitude" });
        }
      } else if (e.target.name === "longitude") {
        if (
          !/^-?([1]?[1-7][1-9]|[1]?[1-8][0]|[1-9]?[0-9])\.{1}\d{1,6}$/.test(
            e.target.value
          )
        ) {
          this.setState({ [`${e.target.name}Error`]: "Invalid Longitude" });
        }
      }
    }
  }

  handleCountryChange(e) {
    if (this.state.countryError !== "") {
      this.setState({ countryError: "" });
    }
    const selectedcountry = this.state.countries.find(
      k => k.country == e.target.value
    );
    this.setState({ country: e.target.value });
    this.setState({ countryName: selectedcountry.countryName });
    this.props.get_state(e.target.value);
  }
  handleStateSelect(e) {
    if (this.state.stateError !== "") {
      this.setState({ stateError: "" });
    }
    const selectedState = this.state.countryStates.find(
      k => k.state == e.target.value
    );
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ stateAbbr: selectedState.stateAbbr });
  }

  handleTimezoneSelect(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ timezone: e.target.value });
  }

  handleValidation() {
    let formIsValid = true;
    this.state.timezoneError = false;
    this.state.titleError = false;
    // (this.state.nationalMultiplierError = false),
      (this.state.latitudeError = false),
      (this.state.longitudeError = false);
    if (!this.state.title) {
      formIsValid = false;
      this.setState({
        titleError: "red"
      });
    }
    if (!this.state.country) {
      formIsValid = false;
      this.setState({
        countryError: "red"
      });
    }
    if (!this.state.state) {
      formIsValid = false;
      this.setState({
        stateError: "red"
      });
    }
    if (!this.state.timezone) {
      formIsValid = false;
      this.setState({
        timezoneError: "red"
      });
    }
    return formIsValid;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.handleValidation()) {
      if (this.state.cityID !== "") {
        const updateData = {
          cityID: this.state.cityID,
          title: this.state.title,
          state: this.state.state,
          stateAbbr: this.state.stateAbbr,
          country: this.state.country,
          countryName: this.state.countryName,
          timezone: this.state.timezone,
          //nationalMultiplier: this.state.nationalMultiplier,
          latitude: this.state.latitude,
          longitude: this.state.longitude
        };
        this.props.update_city(updateData);
      } else if (this.state.cityID === "") {
        const postData = {
          title: this.state.title,
          state: this.state.state,
          stateAbbr: this.state.stateAbbr,
          country: this.state.country,
          countryName: this.state.countryName,
          timezone: this.state.timezone,
          //nationalMultiplier: this.state.nationalMultiplier,
          latitude: this.state.latitude,
          longitude: this.state.longitude
        };
        this.props.add_city(postData);
      }
    }
  }
  render() {
    let stateObjectItems, timezoneObjectItems, countryObjectItems;
    const country = this.props.countries ? this.props.countries : [];
    if (country.length > 0) {
      countryObjectItems = country.map((countryObject, index) => (
        // Only do this if items have no stable IDs
        <option key={index} value={countryObject.country}>
          {countryObject.countryName}
        </option>
      ));
    }
    if (this.state.countryStates.length > 0) {
      stateObjectItems = this.state.countryStates.map((stateObject, index) => (
        // Only do this if items have no stable IDs
        <option key={index} value={stateObject.state}>
          {stateObject.state}
        </option>
      ));
    }
    if (this.state.timezones.length > 0) {
      timezoneObjectItems = this.state.timezones.map(
        (timezoneObject, index) => (
          // Only do this if items have no stable IDs
          <option key={timezoneObject.zoneID} value={timezoneObject.zoneName}>
            {timezoneObject.zoneName}
          </option>
        )
      );
    }

    let pageTitle = this.state.title ? "Edit City" : "Add City";

    return (
      <div className="col-lg-12 add-city">
        <BreadcrumbComponent path={this.state.path} links={this.state.links}/>

        <div className="panel">
          <header className="panel-heading">{pageTitle}</header>
          <div className="panel-body">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong className="alert-msg-type">
                      {this.state.msgType}:
                    </strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <form onSubmit={this.handleSubmit}>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formBasicTitle">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span>Title
                      </ControlLabel>
                      <FormControl
                        type="text"
                        name="title"
                        value={this.state.title}
                        placeholder="Enter text"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.titleError }}
                      />
                    </FormGroup>
                    {/* <FormGroup controlId="formBasicNational">
                      <ControlLabel>National Multiplier</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.nationalMultiplier}
                        placeholder="Enter text"
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        name="nationalMultiplier"
                      />
                      {this.state.nationalMultiplierError && (
                        <Tooltip
                          placement="bottom"
                          className="in"
                          id="tooltip-bottom"
                        >
                          {this.state.nationalMultiplierError}
                        </Tooltip>
                      )}
                    </FormGroup> */}

                    <FormGroup controlId="formBasicLatitude">
                      <ControlLabel>
                        Latitude (format: 0.0 Or -0.0)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.latitude}
                        placeholder="Enter text"
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        name="latitude"
                      />
                      {this.state.latitudeError && (
                        <Tooltip
                          placement="bottom"
                          className="in"
                          id="tooltip-bottom"
                        >
                          {this.state.latitudeError}
                        </Tooltip>
                      )}
                    </FormGroup>

                    <FormGroup controlId="formBasicLongitude">
                      <ControlLabel>
                        Longitude(format: 0.0 Or -0.0)
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.longitude}
                        placeholder="Enter text"
                        onChange={this.handleChange}
                        onBlur={this.handleBlur}
                        name="longitude"
                      />
                      {this.state.longitudeError && (
                        <Tooltip
                          placement="bottom"
                          className="in"
                          id="tooltip-bottom"
                        >
                          {this.state.longitudeError}
                        </Tooltip>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6} xs={12}>
                    {this.state.isLoading ? (
                      <div className="loader">
                        <p className="loading-message">
                          <i>Loading...</i>
                        </p>
                        <div className="spinner">
                          <div className="dot1" />
                          <div className="dot2" />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <FormGroup controlId="formControlsSelectCountry">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span>Country Name
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="country"
                        value={this.state.country}
                        style={{ borderColor: this.state.countryError }}
                        placeholder="Select Country"
                        onChange={this.handleCountryChange}
                      >
                        <option value="">Select Country</option>
                        {countryObjectItems}
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formControlsSelectstate">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span>State
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="state"
                        value={this.state.state}
                        style={{ borderColor: this.state.stateError }}
                        placeholder="Select State"
                        onChange={this.handleStateSelect}
                      >
                        <option value="">Select State</option>
                        {stateObjectItems}
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formControlsSelectTimezone">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span>Timezone
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="timezone"
                        value={this.state.timezone}
                        style={{ borderColor: this.state.timezoneError }}
                        placeholder="Select Timezone"
                        onChange={this.handleTimezoneSelect}
                      >
                        <option value="">Select Timezone</option>
                        {timezoneObjectItems}
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col md={12} xs={12}>
                    <Button
                      bsStyle="primary"
                      disabled={this.props.sendingCityData}
                      type="submit"
                    >
                      Submit
                    </Button>
                    <Button
                      bsStyle="default"
                      onClick={() => history.push(`/cityAndCountry`)}
                    >
                      Cancel
                    </Button>
                  </Col>
                </form>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AddCity.propTypes = {
  add_city: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  states: state.countryCityReducers.states,
  cityDetails: state.countryCityReducers.cityDetails,
  timezones: state.countryCityReducers.timezones,
  countries: state.countryCityReducers.countries,
  error: state.countryCityReducers.error,
  fetchingState: state.countryCityReducers.fetchingState,
  fetchCity: state.countryCityReducers.fetchCity,
  sendingCityData: state.countryCityReducers.sendingCityData,
  fetchingTimezone: state.countryCityReducers.fetchingTimezone,
  cityResponse: state.countryCityReducers.cityResponse,
  cityUpdate: state.countryCityReducers.cityUpdate
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    get_country,
    add_city,
    get_state,
    get_city_details,
    update_city,
    get_timezone
  })
)(AddCity);



// WEBPACK FOOTER //
// ./src/app/views/cityAndCountry/AddCity.js